import Experience from "@folio-2026/experience"
import { lerp } from "@folio-2026/shared"
import * as THREE from "three/webgpu"

// ? Move Camera to shared? (it will be used in section and on each sections)

export default class Camera {
  experience: Experience
  scene: THREE.Scene
  sizes: Experience["sizes"]
  debug: Experience["debug"]
  camera!: THREE.PerspectiveCamera
  cameraHelper!: THREE.CameraHelper

  pointer: Experience["pointer"]
  mouseOffset = { x: 0, y: 0 }
  currentMouseCoords = { x: 0, y: 0 }

  readonly mouseSensitivityX = 0.02 // How much the camera responds to mouse movement on X axis
  readonly mouseSensitivityY = 0.02 // How much the camera responds to mouse movement on Y axis
  readonly maxOffsetX = 0.3 // Maximum offset in world units for X axis
  readonly maxOffsetY = 0.0 // Maximum offset in world units for Y axis

  readonly lerpSpeed = 0.05 // How fast the camera moves to the target position

  constructor({ scene }: { scene: THREE.Scene }) {
    this.experience = Experience.getInstance()
    this.scene = scene
    this.sizes = this.experience.sizes
    this.debug = this.experience.debug
    this.pointer = this.experience.pointer

    this.setCamera()
  }

  setCamera() {
    const { width, height } = this.sizes
    this.camera = new THREE.PerspectiveCamera(40, width / height)

    this.scene.add(this.camera)
  }

  calculateOffset() {
    this.mouseOffset.x = Math.max(
      -this.maxOffsetX,
      Math.min(
        this.maxOffsetX,
        this.currentMouseCoords.x * this.mouseSensitivityX,
      ),
    )
    this.mouseOffset.y = Math.max(
      -this.maxOffsetY,
      Math.min(
        this.maxOffsetY,
        this.currentMouseCoords.y * this.mouseSensitivityY,
      ),
    )
  }

  /**
   * Lerp mouse coordinates for smooth movement
   */
  lerpPosition() {
    this.currentMouseCoords.x = lerp(
      this.currentMouseCoords.x,
      this.pointer.ndcX,
      this.lerpSpeed,
    )
    this.currentMouseCoords.y = lerp(
      this.currentMouseCoords.y,
      this.pointer.ndcY,
      this.lerpSpeed,
    )
  }

  update() {}

  resize() {
    const { width, height } = this.sizes

    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()
  }
}
